import SunAccent from "@/components/feature/SunAccent";
import Reveal from "@/components/base/Reveal";
import { whyPoints, journeyMoments } from "@/mocks/siteData";

export default function WhySection() {
  return (
    <section id="why" className="sun-glaze bg-background-50 py-20 md:py-28">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <Reveal className="lg:col-span-6">
            <div className="flex items-center gap-3 mb-5">
              <SunAccent circleClassName="w-8 h-8" iconClassName="text-base" /><span className="h-px w-10 bg-accent-500"></span>
              <span className="text-xs font-semibold tracking-[0.24em] uppercase text-accent-600">
                Why We Exist
              </span>
            </div>
            <h2 className="font-heading text-3xl md:text-5xl leading-tight text-foreground-950 font-semibold">
              Why Rythugaru Agri Tourism?
            </h2>

            <div className="mt-8 space-y-5">
              {whyPoints.map((point) => (
                <p key={point} className="text-base md:text-lg text-foreground-700 leading-relaxed">
                  {point}
                </p>
              ))}
            </div>

            <div className="mt-9 bg-primary-50 border-l-4 border-primary-500 rounded-r-lg p-6 md:p-7">
              <i className="ri-double-quotes-l text-3xl text-primary-400"></i>
              <p className="font-heading text-xl md:text-2xl text-primary-900 leading-snug mt-2">
                Rythugaru Agri Tourism creates that connection.
              </p>
            </div>

            <p className="mt-6 text-base md:text-lg text-foreground-700 leading-relaxed">
              We invite families, children, students, professionals, corporates, and travelers
              to step into the world of farming and experience rural life beyond the city.
            </p>
          </Reveal>

          <Reveal className="lg:col-span-6" delay={120}>
            <div className="rounded-lg overflow-hidden w-full h-64 md:h-80 mb-8">
              <img
                src="https://readdy.ai/api/search-image?query=Close%20fresh%20portrait%20of%20an%20Indian%20farmers%20hands%20holding%20freshly%20harvested%20rice%20grains%20and%20dark%20fertile%20soil%2C%20natural%20sunlight%2C%20green%20fields%20blurred%20behind%2C%20painterly%20stylized%20lush%20green%20tones%2C%20authentic%20rural%20story%2C%20flooded%20with%20golden%20sunrise%20light%2C%20warm%20amber%20sunrays%20and%20soft%20glow%2C%20misty%20atmospheric%20haze%2C%20deep%20rich%20shadows%2C%20vivid%20saturated%20lush%20green%2C%20high%20contrast%20cinematic%20golden%20hour%20richness%2C%20ultra%20detailed&nocache=true&width=1200&height=800&seq=rythugaru-farmer-hands-soil&orientation=landscape"
                width={1200}
                height={800}
                alt="A farmer's hands holding fresh harvest and soil"
                title="Rythugaru farmer first authentic experiences"
                className="w-full h-full object-cover object-top"
                decoding="async"
              />
            </div>

            <div className="bg-background-100 rounded-lg p-6 md:p-8">
              <h3 className="font-heading text-2xl md:text-3xl text-foreground-950 font-semibold">
                Experience the Life Behind Your Food
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-6">
                {journeyMoments.map((moment) => (
                  <div key={moment.text} className="flex items-start gap-3">
                    <span className="w-9 h-9 shrink-0 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                      <i className={`${moment.icon} text-lg`}></i>
                    </span>
                    <span className="text-sm text-foreground-700 leading-snug pt-1.5">
                      {moment.text}
                    </span>
                  </div>
                ))}
              </div>

              <div className="flex flex-wrap gap-x-6 gap-y-2 mt-7 pt-6 border-t border-background-300">
                <span className="font-heading text-lg text-primary-700 italic">It is an experience.</span>
                <span className="font-heading text-lg text-accent-600 italic">It is a connection.</span>
                <span className="font-heading text-lg text-secondary-700 italic">A journey back to our roots.</span>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}